import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ActivityUpdate as UpdateActivityForModalMutation,
    ActivityUpdateVariables as UpdateActivityForModalVariables,
    ActivityUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_ACTIVITY_FOR_MODAL from '../mutations/update-activity-for-modal.graphql';

export const useUpdateActivityForModal = (): {
    updateActivityForModal: (arg1: ActivityUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateActivityForModal, {loading, error}] = useMutation<
        UpdateActivityForModalMutation,
        UpdateActivityForModalVariables
    >(UPDATE_ACTIVITY_FOR_MODAL);

    return {
        updateActivityForModal: (input: ActivityUpdateInput) =>
            updateActivityForModal({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
